import { useState } from 'react';

import { uniqBy } from 'ramda';
import { useForm, useFormState } from 'react-final-form';

import { getPartnerAgents, submitPartnerAgent } from 'api/partnerAgent';
import { getErrorsMap } from 'utils/common';

export function useWhiteLabeling() {
  const form = useForm();
  const { values, initialValues, dirtyFields } = useFormState();
  const [isAddingNewPartner, setIsAddingNewPartner] = useState(false);
  const loadPartnerAgentsOptions = async (search) => {
    const INFINITY_LIMIT = 999_999;
    const data = await getPartnerAgents(search, 1, INFINITY_LIMIT);

    return uniqBy(
      (opt) => opt.value,
      [
        ...data.data.map((item) => ({ value: item.id, label: getPartnerLabel(item) })),
        ...(initialValues.partnerAgent && !dirtyFields.partnerAgentId
          ? [{ value: initialValues.partnerAgent.id, label: getPartnerLabel(initialValues.partnerAgent) }]
          : []),
      ],
    );
  };

  const handleSetAddingPartner = () => {
    setIsAddingNewPartner(true);
  };

  const handleSubmit = (newPartnerValues, newPartnerForm) => {
    const needRemoveLogo = newPartnerValues.logo === undefined && newPartnerForm.getState()?.dirtyFields?.logo;

    return submitPartnerAgent(newPartnerValues, needRemoveLogo)
      .then((data) => {
        form.change('partnerAgentId', data.id);
        form.change('partnerAgent', data);

        setIsAddingNewPartner(false);
      })
      .catch((err) => {
        if (err.axiosResponse.status === 422) {
          return getErrorsMap(err);
        }
      });
  };

  const handleCloseForm = () => {
    setIsAddingNewPartner(false);
  };

  const handleChange = (value) => {
    form.change('partnerAgentId', value);
    if (value === null) {
      form.change('partnerAgent', undefined);
    }
  };

  return {
    form,
    values,
    isAddingNewPartner,
    loadPartnerAgentsOptions,
    handleSetAddingPartner,
    handleSubmit,
    handleCloseForm,
    handleChange,
  };
}

export function getPartnerLabel({ consultantFirstName, consultantLastName, companyName } = {}) {
  return [consultantFirstName, consultantLastName].join(' ') + ` (${companyName})`;
}
